module.exports = __webpack_public_path__ + "static/img/20241224_1.e7d7c65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2024/20241224_1.png
// module id = Xjup
// module chunks = 0